module.exports = __webpack_public_path__ + "img/img38.81e5c9d4.svg";